import { PagingResultsViewModel, TUsuarioPerfilViewModel, EnumSiNoTodos, FilterSearchingBaseViewModel } from '../../../core/_infrastructure/types/common';

export class AltaUsuarioExternoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: VListaUsuariosExternosItemViewModel[];
}

export class VListaUsuariosExternosItemViewModel {
    public IdUsuario: number;
    public RazonSocial = '';
    public NombreUsuarioCexveg = '';
    public IdPais: number;
    public IdProvincia: number;
    public IdMunicipio: number;
    public NumeroTelefono = '';
    public NumeroFax = '';
    public CodigoPostal = '';
    public IdTipoVia: number;
    public NombreVia = '';
    public NumeroPortal = '';
    public NifCifRazonSocial = '';
    public FechaCreacion: Date;
    public FechaActivacion: Date;
    public FechaBaja: Date;
    public NombreRepresentante = '';
    public ApellidosRepresentante = '';
    public NifRepresentante = '';
    public LocalidadTraces = '';
}

export class FilterSearchingVListaUsuariosExternosViewModel extends FilterSearchingBaseViewModel {
    public IdPais: number | null = null;
    public IdProvincia: number | null = null;
    public IdMunicipio: number | null = null;
    public LocalidadTraces = '';
    public RazonSocial = '';
    public NifCifRazonSocial = '';
    public Apellidos = '';
    public Nombre = '';
    public Nif = '';
    public NombreUsuarioCexveg = '';
    public Email = '';
    public Activo: number = EnumSiNoTodos.TODOS;
}

export class AltaUsuarioExternoViewModel {
    constructor() {}

    public Id: number;
    public Activo = false;
    public Nif = '';
    public Nombre = '';
    public Apellidos = '';
    public Email = '';
    public FechaCreacion: Date;
    public FechaActivacion: Date;
    public FechaBaja: Date;
    public NombreUsuarioCexveg = '';
    public TwUsuarioExterno: UsuarioExternoViewModel;
    public TUsuarioPerfilCollection: TUsuarioPerfilViewModel[];
}

export class UsuarioExternoViewModel {
    constructor() {}

    public IdUsuario: number;
    public RazonSocial = '';
    public IdPais: number;
    public IdProvincia: number;
    public IdMunicipio: number;
    public NumeroTelefono = '';
    public NumeroFax = '';
    public CodigoPostal = '';
    public IdTipoVia: number;
    public NombreVia = '';
    public NumeroPortal = '';
    public NifCifRazonSocial = '';
    public NombreRepresentante = '';
    public ApellidosRepresentante = '';
    public NifRepresentante = '';
    public LocalidadTraces = '';
}
